export var EAuthenticateStatus = /*#__PURE__*/function (EAuthenticateStatus) {
  EAuthenticateStatus["Initial"] = "initial";
  EAuthenticateStatus["Loading"] = "loading";
  EAuthenticateStatus["Succeed"] = "succeed";
  EAuthenticateStatus["Failed"] = "failed";
  return EAuthenticateStatus;
}({});
export var EAuthenticateError = /*#__PURE__*/function (EAuthenticateError) {
  EAuthenticateError["Common"] = "common";
  EAuthenticateError["EmailRequired"] = "emailRequired";
  EAuthenticateError["EmailTaken"] = "emailTaken";
  EAuthenticateError["Unexpected"] = "unexpected";
  return EAuthenticateError;
}({});